import styled from '@emotion/styled';
import { Body1, PopoverSurface } from '@fluentui/react-components';

export const CustomPopoverSurface = styled(PopoverSurface)`
  max-width: 500px;
`;

export const CustomPopoverSurfaceFilter = styled(PopoverSurface)`
  max-height: 30vh;
  overflow: auto;
`;

export const CustomPopoverSurfaceError = styled(PopoverSurface)`
  max-height: 30vh;
  overflow: auto;
`;

export const TableBody = styled.tbody`
  border-bottom: 0;
`;

export const TableRow = styled.tr`
  vertical-align: top;
`;

export const TableDataTitle = styled.td`
  padding-right: 10px;
`;

export const TableDataBody1Title = styled(Body1)`
  white-space: nowrap;
`;

export const TableDataInnerList = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 12px;
`;

export const TableDataBody1Text = styled(Body1)`
  word-break: break-word;
`;

export const SubjectContainer = styled.div`
  padding-bottom: 1rem;
`;

export const CustomList = styled.ul`
  margin: 0;
  padding: 0 1rem;
`;

export const FilterListItem = styled.li`
  padding-top: ${(props) => (props.first ? '6px' : 0)};
  padding-bottom: ${(props) => (props.noBottomPadding ? '0' : '1rem')};
`;

export const ErrorList = styled.ul`
  margin: 6px 0;
  padding: 0 0.5rem;
  list-style: none;
`;
